// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmailCheckPage__root--qfKk {
    max-width: 632px;
    margin: 0 auto;
}

.EmailCheckPage__section--SvnO {
    padding: 20px;
    background-color: var(--tertiary-color);
    border: 4px solid var(--obscure-color);
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 24px;
    margin-bottom: 24px;
}

.EmailCheckPage__sectionWithWarning--zSuZ {
    border-color: var(--warning-color);
}

.EmailCheckPage__wrapper--CAx1 {
    width: 100%;
}

.EmailCheckPage__title--Gl_n {
    margin-bottom: 4px;
    font-size: 26px;
    line-height: 34px;
    font-weight: 700;
    color: var(--darkest-color);
}

.EmailCheckPage__secondaryTitle--idep {
    margin-bottom: 4px;
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    color: var(--darkest-color);
}

.EmailCheckPage__description--eaNQ {
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
    color: var(--darkest-color);
    margin-bottom: 24px;
}

.EmailCheckPage__description--eaNQ > strong {
        font-weight: 700;
    }

.EmailCheckPage__resultBlock--d4zA {
    display: flex;
    flex-direction: column;
    color: var(--secondary-color);
}

.EmailCheckPage__resultBlock--d4zA > span:first-child {
        font-weight: 600;
        font-size: 15px;
        line-height: 20px;
    }

.EmailCheckPage__resultBlock--d4zA > span:last-child {
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;        
    }

.EmailCheckPage__resultList--EPaF {
    display: flex;
    flex-direction: column;
    background-color: var(--tertiary-color);
    border: 4px solid var(--obscure-color);
    border-radius: 12px;
}

.EmailCheckPage__resultListItem--sHP4 {
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.EmailCheckPage__resultListItem--sHP4:not(:last-child) {
        border-bottom: 1px solid var(--obscure-color);
    }

.EmailCheckPage__listItemWrapper--N3zu {
    display: grid;
    grid-template-columns: 48px auto;
    align-items: center;
    grid-gap: 12px;
}

.EmailCheckPage__listItemWrapper--N3zu > img {
        width: 48px;
        height: 48px;
        padding: 12px;
        border-radius: 6px;
        background-color: #B8BFD2;
        display: block;
        -o-object-fit: contain;
           object-fit: contain;
        -o-object-position: center;
           object-position: center;
    }

.EmailCheckPage__listItemWrapper--N3zu > span {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: var(--darkest-color);
    }

.EmailCheckPage__listItemDescription--knt6 {
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: var(--secondary-color);
}

.EmailCheckPage__listItemDescription--knt6 > a {
        text-decoration: underline;
        color: var(--secondary-color);
    }

.EmailCheckPage__compromisedList--qC0p {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.EmailCheckPage__compromisedListTitle--ZbYz {
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: var(--secondary-color);
}

.EmailCheckPage__compromisedListItem--YTy1 {
    background: #545F921A;
    border-radius: 28px;
    padding: 4px 8px;
    font-family: Poppins;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: var(--secondary-color);
}

.EmailCheckPage__loader--lONx {
    display: block;
    margin: 40px auto;
}

.EmailCheckPage__smallLoader--PDiO {
    --loader-size: 24px !important;
    margin: 0;
}

.EmailCheckPage__form--d1Df {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

@media screen and (min-width: 1024px), screen and (min-width: 768px) and (max-width: 1024px) {

.EmailCheckPage__form--d1Df {
        display: grid;
        grid-template-columns: auto 108px;
        grid-gap: 16px;
        align-items: start
}
    }

.EmailCheckPage__input--vyCO input {
        border-radius: 48px;
    }

.EmailCheckPage__button--W1us {
    border-radius: 42px;
}

.EmailCheckPage__noteBlock--K8xj {
    background-color: var(--tertiary-color);
    border: 4px solid var(--obscure-color);
    border-radius: 12px;
    padding: 20px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: var(--secondary-color);
}

.EmailCheckPage__noteBlock--K8xj > strong {
        font-weight: 700;
    }
`, "",{"version":3,"sources":["webpack://./src/ui/pages/EmailCheckPage/EmailCheckPage.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uCAAuC;IACvC,sCAAsC;IACtC,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,mBAAmB;AAKvB;;AAHI;QACI,gBAAgB;IACpB;;AAGJ;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;AAajC;;AAXI;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;;AAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;IACrB;;AAGJ;IACI,aAAa;IACb,sBAAsB;IACtB,uCAAuC;IACvC,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AAKb;;AAHI;QACI,6CAA6C;IACjD;;AAGJ;IACI,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,cAAc;AAmBlB;;AAjBI;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,kBAAkB;QAClB,yBAAyB;QACzB,cAAc;QACd,sBAAmB;WAAnB,mBAAmB;QACnB,0BAAuB;WAAvB,uBAAuB;IAC3B;;AAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,2BAA2B;IAC/B;;AAGJ;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AAMjC;;AAJI;QACI,0BAA0B;QAC1B,6BAA6B;IACjC;;AAGJ;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AAQb;;AANI;;AALJ;QAMQ,aAAa;QACb,iCAAiC;QACjC,cAAc;QACd;AAER;IADI;;AAIA;QACI,mBAAmB;IACvB;;AAGJ;IACI,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;IACvC,sCAAsC;IACtC,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;AAKjC;;AAHI;QACI,gBAAgB;IACpB","sourcesContent":[".root {\n    max-width: 632px;\n    margin: 0 auto;\n}\n\n.section {\n    padding: 20px;\n    background-color: var(--tertiary-color);\n    border: 4px solid var(--obscure-color);\n    border-radius: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    margin-bottom: 24px;\n}\n\n.sectionWithWarning {\n    border-color: var(--warning-color);\n}\n\n.wrapper {\n    width: 100%;\n}\n\n.title {\n    margin-bottom: 4px;\n    font-size: 26px;\n    line-height: 34px;\n    font-weight: 700;\n    color: var(--darkest-color);\n}\n\n.secondaryTitle {\n    margin-bottom: 4px;\n    font-size: 24px;\n    line-height: 32px;\n    font-weight: 700;\n    color: var(--darkest-color);\n}\n\n.description {\n    font-size: 15px;\n    line-height: 20px;\n    font-weight: 400;\n    color: var(--darkest-color);\n    margin-bottom: 24px;\n\n    > strong {\n        font-weight: 700;\n    }\n}\n\n.resultBlock {\n    display: flex;\n    flex-direction: column;\n    color: var(--secondary-color);\n\n    > span:first-child {\n        font-weight: 600;\n        font-size: 15px;\n        line-height: 20px;\n    }\n\n    > span:last-child {\n        font-weight: 700;\n        font-size: 24px;\n        line-height: 32px;        \n    }\n}\n\n.resultList {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--tertiary-color);\n    border: 4px solid var(--obscure-color);\n    border-radius: 12px;\n}\n\n.resultListItem {\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    &:not(:last-child) {\n        border-bottom: 1px solid var(--obscure-color);\n    }\n}\n\n.listItemWrapper {\n    display: grid;\n    grid-template-columns: 48px auto;\n    align-items: center;\n    grid-gap: 12px;\n\n    > img {\n        width: 48px;\n        height: 48px;\n        padding: 12px;\n        border-radius: 6px;\n        background-color: #B8BFD2;\n        display: block;\n        object-fit: contain;\n        object-position: center;\n    }\n\n    > span {\n        font-weight: 600;\n        font-size: 16px;\n        line-height: 24px;\n        color: var(--darkest-color);\n    }\n}\n\n.listItemDescription {\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 20px;\n    color: var(--secondary-color);\n\n    > a {\n        text-decoration: underline;\n        color: var(--secondary-color);\n    }\n}\n\n.compromisedList {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.compromisedListTitle {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 16px;\n    color: var(--secondary-color);\n}\n\n.compromisedListItem {\n    background: #545F921A;\n    border-radius: 28px;\n    padding: 4px 8px;\n    font-family: Poppins;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 16px;\n    color: var(--secondary-color);\n}\n\n.loader {\n    display: block;\n    margin: 40px auto;\n}\n\n.smallLoader {\n    --loader-size: 24px !important;\n    margin: 0;\n}\n\n.form {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n\n    @media (--large), (--small-tablet) {\n        display: grid;\n        grid-template-columns: auto 108px;\n        grid-gap: 16px;\n        align-items: start;\n    }\n}\n\n.input {\n    input {\n        border-radius: 48px;\n    }\n}\n\n.button {\n    border-radius: 42px;\n}\n\n.noteBlock {\n    background-color: var(--tertiary-color);\n    border: 4px solid var(--obscure-color);\n    border-radius: 12px;\n    padding: 20px;\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 24px;\n    text-align: center;\n    color: var(--secondary-color);\n\n    > strong {\n        font-weight: 700;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `EmailCheckPage__root--qfKk`,
	"section": `EmailCheckPage__section--SvnO`,
	"sectionWithWarning": `EmailCheckPage__sectionWithWarning--zSuZ`,
	"wrapper": `EmailCheckPage__wrapper--CAx1`,
	"title": `EmailCheckPage__title--Gl_n`,
	"secondaryTitle": `EmailCheckPage__secondaryTitle--idep`,
	"description": `EmailCheckPage__description--eaNQ`,
	"resultBlock": `EmailCheckPage__resultBlock--d4zA`,
	"resultList": `EmailCheckPage__resultList--EPaF`,
	"resultListItem": `EmailCheckPage__resultListItem--sHP4`,
	"listItemWrapper": `EmailCheckPage__listItemWrapper--N3zu`,
	"listItemDescription": `EmailCheckPage__listItemDescription--knt6`,
	"compromisedList": `EmailCheckPage__compromisedList--qC0p`,
	"compromisedListTitle": `EmailCheckPage__compromisedListTitle--ZbYz`,
	"compromisedListItem": `EmailCheckPage__compromisedListItem--YTy1`,
	"loader": `EmailCheckPage__loader--lONx`,
	"smallLoader": `EmailCheckPage__smallLoader--PDiO`,
	"form": `EmailCheckPage__form--d1Df`,
	"input": `EmailCheckPage__input--vyCO`,
	"button": `EmailCheckPage__button--W1us`,
	"noteBlock": `EmailCheckPage__noteBlock--K8xj`
};
export default ___CSS_LOADER_EXPORT___;
